<template>
    <brand-assets-provider v-slot="{
        campaign,
        proposal,
        proposalStep,
        goNextStep,
        goPreviousStep,
        isLoading,
        isCompletingProposal,
    }" style="height: 100%">
        <proposal-assets-view
            :campaign="campaign"
            :proposal-step="proposalStep"
            :proposal="proposal"
            :is-loading="isLoading"
            :is-completing-proposal="isCompletingProposal"
            @go-next-step="goNextStep"
            @go-previous-step="goPreviousStep"
        />
    </brand-assets-provider>
</template>
<script>
    import ProposalAssetsView from "../data-views/proposals/ProposalAssetsView";
    import BrandAssetsProvider from "../providers/proposal-steps/BrandAssetsProvider";

    export default {
        name: "ProposalAssetsRouterView",
        components: {
            BrandAssetsProvider,
            ProposalAssetsView,
        }
    }
</script>
